module.exports = __webpack_public_path__ + "static/media/pic-st6.4e8d7b6b.jpg";